import React from 'react';
import { motion } from 'framer-motion';

const RiskPulse = ({ level = 'stable' }) => {
  const configs = {
    stable: { color: 'bg-emerald-500', shadow: 'shadow-emerald-500/50', duration: 3 },
    warning: { color: 'bg-amber-500', shadow: 'shadow-amber-500/50', duration: 1.5 },
    critical: { color: 'bg-rose-500', shadow: 'shadow-rose-500/50', duration: 0.8 },
  };

  const { color, shadow, duration } = configs[level];

  return (
    <div className="relative flex items-center justify-center w-4 h-4">
      {level !== 'stable' && (
        <motion.div
          animate={{ scale: [1, 2.5], opacity: [0.7, 0] }}
          transition={{ duration, repeat: Infinity, ease: "easeOut" }}
          className={`absolute w-full h-full rounded-full ${color} opacity-70`}
        />
      )}
      <div className={`relative w-2 h-2 rounded-full ${color} ${shadow} shadow-lg`} />
    </div>
  );
};

export default RiskPulse;